import { makeAutoObservable, runInAction } from "mobx";

import { IMessage } from "@/shared/types";

import { messageHistoryService } from "../api/messageHistoryService";
import { IGetHistoryParams, MessageStatus } from "../types";

export class MessageHistoryStore {
  messages: IMessage[] = [];

  nextCursor: string | null = null;

  private _scrollToBottomCallback: (() => void) | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setScrollToBottomCallback(cb: (() => void) | null) {
    this._scrollToBottomCallback = cb;
  }

  scrollToBottom() {
    this._scrollToBottomCallback?.();
  }

  addLocalMessage(message: IMessage) {
    this.messages.unshift(message);
  }

  updateLastMessageId(id: string) {
    const lastMessage = this.messages.at(0);
    if (lastMessage) {
      lastMessage.message_id = id;
    }
  }

  updateMessageText(id: string, text: string) {
    const messageToUpdate = this.messages.find((msg) => msg.message_id === id);
    if (messageToUpdate) {
      messageToUpdate.msg += text;
    }
  }

  updateMessageStatus(id: string, status: MessageStatus) {
    const messageToUpdate = this.messages.find((msg) => msg.message_id === id);
    if (messageToUpdate) {
      messageToUpdate.status = status;
    }
  }

  deleteFailedMessage(id: string) {
    this.messages = this.messages.filter((msg) => msg.message_id !== id);
  }

  clearState() {
    this.messages = [];
    this.nextCursor = null;
  }

  async loadInitialHistory(params: IGetHistoryParams) {
    const response = await messageHistoryService.getHistory({
      ...params,
      limit: 20,
    });

    runInAction(() => {
      this.nextCursor = response.next_cursor;
      this.messages = response.data;
    });

    return response;
  }

  async loadMoreHistory(params: IGetHistoryParams) {
    const response = await messageHistoryService.getHistory({
      limit: 20,
      ...params,
      ...(this.nextCursor && {
        cursor: this.nextCursor,
      }),
    });

    runInAction(() => {
      this.nextCursor = response.next_cursor;
      this.messages = [...this.messages, ...response.data];
    });

    return response;
  }
}
